export const getUserInitialAndColor = (email: string) => {
  const colors = ['#70B5B0', '#57667A', '#6699B2', '#E3A382', '#D1BA73'];
  const initials = email[0];
  const color = colors[email.length % colors.length];
  return { initials, color };
};
